import {classes} from '@bitstillery/common/lib/utils'
import {Icon} from '@bitstillery/common/components/ui/icon/icon'
import {MithrilComponent} from '@bitstillery/mithril'
import {modelref_adapter, modelref_assign} from '@bitstillery/common/lib/store'
import m from '@bitstillery/mithril'

import type {FieldTextAreaAttrs} from '@bitstillery/common/types/field'
import {failure_message} from '@bitstillery/common/lib/validation'

export class FieldTextArea extends MithrilComponent<FieldTextAreaAttrs> {
    view(vnode: m.Vnode<FieldTextAreaAttrs>) {
        const {model_value, model_ref} = modelref_adapter(vnode.attrs.model)
        if (model_ref === null) {
            return null
        }
        const {validation} = vnode.attrs
        const invalid = validation ? validation._invalid : false
        const {disabled} = vnode.attrs
        return (
            <div
                className={classes('c-field-textarea', 'field', vnode.attrs.className, {
                    disabled: disabled,
                    invalid: validation && invalid && validation.dirty,
                    valid: validation && !invalid && validation.dirty,
                })}
            >
                {vnode.attrs.label && (
                    <label>
                        {vnode.attrs.label}
                        {vnode.attrs.icon && <Icon name={vnode.attrs.icon} />}
                        {validation && <span className='validation'>{validation.label}</span>}
                    </label>
                )}
                <textarea
                    disabled={vnode.attrs.disabled}
                    onfocus={vnode.attrs.onfocus}
                    oninput={(e) => {
                        if (vnode.attrs.validation) {
                            vnode.attrs.validation.dirty = true
                        }
                        modelref_assign(model_ref, e.currentTarget.value)
                    }}
                    placeholder={vnode.attrs.placeholder ? vnode.attrs.placeholder : ''}
                    value={model_value}
                    rows={vnode.attrs.rows}
                >
                    {model_value}
                </textarea>
                {(() => {
                    if (invalid && validation?.dirty) {
                        return <div className='help validation'>{failure_message(invalid)}</div>
                    } else if (vnode.attrs.help) {
                        return <div class='help'>{vnode.attrs.help}</div>
                    }
                    return undefined
                })()}
            </div>
        )
    }
}
